import { useRef, useState } from 'react';

import { ArrowLeftLine, Edit2Line, MapPin2Line } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import Button from '@components/Button';
import TourSearchBar from '@domain/tour/searchBar';
import useSearchBar from '@contexts/searchbar';

import {
  Drawer,
  TourDateAndGuestWrapper,
  TourListMobileHeaderWrapper,
  TourLocationWrapper,
  MobileHeaderBody,
  NavigationButton,
} from './TourListMobileHeaderStyle';

export type ITourSearchBarHandle = {
  triggerHandleSubmit: () => void;
};

interface Props {
  onSubmit?(): void;
  isListing?: boolean;
}

const TourListMobileHeader = ({ onSubmit, isListing = false }: Props) => {
  const {
    state: { tour: state },
  } = useSearchBar();

  const tourSearchBarRef = useRef<ITourSearchBarHandle>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleSubmit = () => {
    setIsDrawerOpen(false);
    onSubmit?.();
    tourSearchBarRef?.current?.triggerHandleSubmit();
  };

  return (
    <>
      <TourListMobileHeaderWrapper>
        <NavigationButton onClick={() => window.history.back()}>
          <CustomIcon
            icon={ArrowLeftLine}
            fontSize={24}
            paletteColor='whiteAlpha600'
          />
        </NavigationButton>
        <MobileHeaderBody>
          <TourLocationWrapper>
            {state.searchData?.text ? (
              <>
                <CustomIcon
                  icon={MapPin2Line}
                  fontSize={20}
                  paletteColor='white'
                />
                <span>{state?.searchData?.text}</span>
              </>
            ) : null}
          </TourLocationWrapper>
          <TourDateAndGuestWrapper />
        </MobileHeaderBody>
        <NavigationButton onClick={() => setIsDrawerOpen(true)}>
          <CustomIcon
            icon={Edit2Line}
            fontSize={24}
            paletteColor='whiteAlpha600'
          />
        </NavigationButton>
      </TourListMobileHeaderWrapper>
      <Drawer
        title='Tur Arama'
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        placement='top'
        footer={
          <Button fullWidth onClick={handleSubmit}>
            Tur Ara
          </Button>
        }
      >
        <TourSearchBar
          ref={tourSearchBarRef}
          isListing={isListing}
          onSubmit={onSubmit}
        />
      </Drawer>
    </>
  );
};

export default TourListMobileHeader;
